import { Box, Heading, Link } from "@chakra-ui/layout"
import { RoundButton } from "../button/Button"
import { colors } from "../colors"

export function TitleCTA({
  title,
  titleColor,
  ctaLink,
  ctaLabel,
  ctaColor,
  backgroundColor,
}) {
  return (
    <Box
      backgroundColor={backgroundColor}
      p={{ base: `51px 20px`, md: "51px 0" }}
    >
      <Heading
        fontSize={{ base: `36px`, md: "40px" }}
        lineHeight={{ base: `34px`, md: `38px` }}
        color={titleColor}
        textAlign="center"
        mb="30px"
        fontWeight="500"
      >
        {title}
      </Heading>

      <Box maxW="322px" m="0 auto">
        <Link
          href={ctaLink}
          textDecoration="none"
          target="_blank"
          _hover={{ textDecoration: `none` }}
        >
          <RoundButton
            _hover={{ backgroundColor: colors.purple, color: colors.lime }}
            _focus={{ backgroundColor: colors.lightBlue }}
            backgroundColor={ctaColor}
            color={backgroundColor}
          >
            {ctaLabel}
          </RoundButton>
        </Link>
      </Box>
    </Box>
  )
}
